const transfers = {
  transfer: "移行", // translated
  transfers: "転送", // translated
  dateAndTime: "日時", // translated
  transferFrom: "からの転送", // translated
  duration: "間隔", // translated
  numOfPersons: "人数", // translated
  baggageAllowance: "手荷物制限", // translated
  small: "小さい", // translated
  big: "大きい", // translated
  provider: "プロバイダー", // translated
  vehicle: "車両", // translated
  distance: "距離", // translated
  price: "価格", // translated
  inboundJourney: "インバウンド旅行", // translated
  outboundJourney: "往路", // translated
  arrivalTime: "到着時刻", // translated
  flightDetails: "フライトの詳細", // translated
  inboundPickupDate: "インバウンド受け取り日", // translated
  outboundPickupDate: "アウトバウンドの集荷日", // translated
  travelInfo: "旅行情報", // translated
  flightsInfo: "フライト情報", // translated
  airportYouAreFlyingFrom: "出発空港", // translated
  airportYouAreFlyingTo: "ご利用の空港", // translated
  inboundFlightNumber: "到着便の便名", // translated
  outboundFlightNumber: "往路便名", // translated
  inboundAirlineName: "往路航空会社名", // translated
  outboundAirlineName: "往路の航空会社名", // translated
  tripMode: "トリップモード", // translated
  airportToPoint: "空港からポイントまで", // translated
  pointToAirport: "空港へのポイント", // translated
  roundTrip: "往復", // translated
  destinationPoint: "目的地", // translated
  originPoint: "原点", // translated
  transferType: "転送タイプ", // translated
  min: "分", // translated
  max: "マックス", // translated
  pieces: "ピース", // translated
  cancelationIs: "キャンセルは", // translated
};



export default transfers;
